import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'

import Form from 'components/form/Form'

import formUtils from 'components/form/utils'
import projectSelectors from 'store/selectors/project'
import adminSelectors from 'store/selectors/admin'
import adminActions from 'store/modules/admin'

import {
  fullUrl,
} from 'utils/url'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
  buttons: {
    marginTop: theme.spacing(4),
  },
  footer: {
    marginTop: theme.spacing(4),
  },
}))

const SCHEMA = [{
  id: 'name',
  title: 'Company Name',
  helperText: 'Enter the name of your company here',
}, {
  id: 'url',
  title: 'URL',
  helperText: `Enter the URL of your booking forms: ${fullUrl()}/<URL>`,
  prependText: `${fullUrl()}/`,
}, {
  id: 'meta.logo',
  title: 'Logo',
  helperText: 'Upload a logo',
  component: 'image',
  path: 'settings',
}, {
  id: 'meta.color',
  title: 'Colour',
  helperText: 'Choose the main Colour',
  component: 'color',
}, [{
  id: 'visibility',
  title: 'Visiblity',
  helperText: 'Should we show your booking forms on our homepage?',
  component: 'radio',
  default: 'private',
  options: [{
    title: 'Private',
    value: 'private',
  }, {
    title: 'Public',
    value: 'public',
  }],
  noTitle: true,
}, {
  id: 'meta.email_notifications',
  title: 'Email Notifications',
  helperText: 'Add a list of email addresses that will receive updates when bookings are made - for ALL booking forms',
  component: 'list',
  list_schema: [{
    id: 'email',
    title: 'Email',
    helperText: 'The email address that will receive updates',
    validate: {
      type: 'string',
      methods: [
        ['required', 'The email is required'],
      ]
    }
  }],
  list_table: [{
    name: 'email',
    title: 'Email',
  }]
}], {
  id: 'meta.description',
  title: 'Description',
  helperText: 'Enter a description of what your company does',
  component: 'textarea',
}]

const HANDLERS = {}

const Settings = ({

}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  
  const loading = useSelector(adminSelectors.updateProject.loading)
  const error = useSelector(adminSelectors.updateProject.error)
  const project = useSelector(projectSelectors.currentProject)

  const initialValues = formUtils.getInitialValues(SCHEMA, project)

  const onSubmit = useCallback((payload) => {
    dispatch(adminActions.updateProject({payload}))
  })

  return (
    <div className={ classes.root }>
      <Paper className={ classes.paper }>
        <Typography gutterBottom variant="h6">
          Project Settings
        </Typography>
        <Form
          schema={ SCHEMA }
          handlers={ HANDLERS }
          error={ error }
          initialValues={ initialValues }
          onSubmit={ onSubmit }
        >
          {
            ({
              isValid,
              onSubmit,
            }) => {
              return (
                <div className={ classes.buttons }>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={ loading || !isValid }
                    onClick={ onSubmit }
                  >
                    Save
                  </Button>
                </div>
              )
            }
          }
        </Form>
      </Paper>
    </div>
  )
}

export default Settings